import { fetchAuthSession } from 'aws-amplify/auth'

export const SESSION_EXPIRED_EVENT = 'backoffice:session-expired'
export const SESSION_EXPIRED_MESSAGE = 'Your session expired. Please sign in again.'

class SessionExpiredError extends Error {
    readonly status = 401

    constructor() {
        super(SESSION_EXPIRED_MESSAGE)
        this.name = 'SessionExpiredError'
    }
}

function expiredSession(): SessionExpiredError {
    window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT))
    return new SessionExpiredError()
}

let tokenRequest: Promise<string> | null = null

async function loadAccessToken(): Promise<string> {
    let session
    try {
        // Amplify renews expired tokens using the current user's refresh token.
        session = await fetchAuthSession()
    } catch (error: any) {
        if (['UserUnAuthenticatedException', 'NotAuthorizedException'].includes(error?.name)) {
            throw expiredSession()
        }
        // A network failure is not evidence that the login session has ended.
        throw error
    }
    const token = session.tokens?.accessToken?.toString()
    if (!token) throw expiredSession()
    return token
}

export function getAccessToken(): Promise<string> {
    // Share concurrent renewals, but check the session again for later requests.
    if (!tokenRequest) {
        tokenRequest = loadAccessToken().finally(() => { tokenRequest = null })
    }
    return tokenRequest
}
